export function formatNumber(value: number): string {
  // Round to 2 decimal places
  const rounded = Number(Math.round(Number(value + "e2")) + "e-2");

  // If it's a whole number, return without decimal places
  if (rounded % 1 === 0) {
    return rounded.toString();
  }

  // Otherwise return with exactly 2 decimal places
  return rounded.toFixed(2);
}

export function formatGoldBars(num: number): string {
  if (num >= 1_000_000_000) return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";
  if (num >= 1_000_000) return (num / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  if (num >= 10_000) return (num / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
  return num.toLocaleString();
}

export function calculateFiatEquivalent(tokenAmount: string, exchangeRate: string): string {
  if (!tokenAmount || !exchangeRate) return "";
  const amount = parseFloat(tokenAmount);
  const rate = parseFloat(exchangeRate);
  if (isNaN(amount) || isNaN(rate)) return "";
  return (amount * rate).toFixed(2);
} 